var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"modalidade","rota-base":"/admin/modalidade","titulo":"MODALIDADES","titulo-singular":"Modalidade","colunas-extras":[{"campo":"descricao","label":"Descrição","tipo":"string"},{"campo":"ordem","label":"Ordem","tipo":"string"}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }